module.exports = __webpack_public_path__ + "static/visa-bitcoin-vityaz-72d5933b69e9264e7ee9f68d715bda1d.png";